export default __webpack_public_path__ + "static/media/tim-settings-icon.b6c2dbbc.png";